import { ActionCreator, bindActionCreators, Dispatch } from "redux";
import { IAnyObjectType } from "../../widgets/components/SelectionBox";
import { IGuide } from "../../widgets/interfaces/model/Guides";
import { GuideActionConstants } from "../reducers/Guide";
import { IResetGuidesAction, ISetGuidesAction, ISetGuideSnapAction } from "../reducers/index";

/**
 * Set guides action creator.
 * @param guides Guides to be added.
 * @returns Set guides line action.
 */
export const setGuides: ActionCreator<ISetGuidesAction> = (guides: IGuide[]): ISetGuidesAction => ({
	transient: true,
	type: GuideActionConstants.SET_GUIDES,
	guides,
});

/**
 * Reset guides action creator.
 * @returns Reset guides action.
 */
export const resetGuides: ActionCreator<IResetGuidesAction> = (): IResetGuidesAction => ({
	transient: true,
	type: GuideActionConstants.RESET_GUIDES,
});

/**
 * Set guide snap details action.
 * @param snapDetails {IAnyObjectType}
 * @return {ISetGuideSnapAction}
 */
export const setGuideSnapDetails: ActionCreator<ISetGuideSnapAction> =
	(snapDetails: IAnyObjectType): ISetGuideSnapAction => ({
		transient: true,
		type: GuideActionConstants.SET_GUIDES_SNAP_DETAILS,
		snapDetails,
	});

/**
 * Guides APIs
 * Collection of redux dispatch bound actions
 */
export const initGuidesAPI = (dispatch: Dispatch<any>) => {
	return bindActionCreators({ resetGuides, setGuides, setGuideSnapDetails }, dispatch);
};
